var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-stepper",
    {
      model: {
        value: _vm.step,
        callback: function ($$v) {
          _vm.step = $$v
        },
        expression: "step",
      },
    },
    [
      _c(
        "v-stepper-items",
        [
          _c(
            "v-stepper-content",
            { staticClass: "pa-0", attrs: { step: 0 } },
            [
              _vm.bookingType === _vm.TYPE_COURSES
                ? _c(
                    "v-list",
                    {
                      staticClass: "pa-1",
                      staticStyle: { "border-radius": "0px" },
                      attrs: { elevation: "2", "three-line": "" },
                    },
                    [
                      _c("v-subheader", [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("overview.bookable_courses")) +
                            " "
                        ),
                      ]),
                      _c("v-data-iterator", {
                        staticClass: "nomargin-firstchild nomargin-lastchild",
                        attrs: {
                          "disable-pagination": "",
                          "hide-default-footer": "",
                          "item-key": "CourseId",
                          items: _vm.itemsToDisplay
                            ? _vm.itemsToDisplay
                            : _vm.getFilteredCourseItems(""),
                          "custom-filter": _vm.customCourseFilter,
                          search: _vm.searchFor,
                          "no-results-text": _vm.$t("common.label_noresults"),
                          "no-data-text": _vm.$t("common.label_nodata"),
                          "sort-by": _vm.sortBy ? _vm.sortBy.key : undefined,
                          "sort-desc": _vm.sortBy
                            ? _vm.sortBy.sortDesc
                            : undefined,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _c(
                                    "v-row",
                                    {
                                      class:
                                        _vm.currentBreakpoint == 1
                                          ? "nomargin-firstchild nomargin-lastchild"
                                          : "",
                                      staticStyle: {
                                        "max-width": "calc(100vw - 32px)",
                                      },
                                      attrs: { "no-gutters": "" },
                                    },
                                    _vm._l(
                                      props.items,
                                      function (course, index) {
                                        return _c("CoursePreviewItem", {
                                          key: "courseListItem" + index,
                                          attrs: {
                                            selected:
                                              _vm.hasSelection &&
                                              _vm.currentSelection.CourseId ===
                                                course.CourseId,
                                            loading:
                                              _vm.loadingElem ===
                                              course.CourseId,
                                            disabled: _vm.loadingElem !== "",
                                            courseId: course.CourseId,
                                          },
                                          on: {
                                            onSelect: function ($event) {
                                              return _vm.handleCourseSelection(
                                                course,
                                                false
                                              )
                                            },
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3510657390
                        ),
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.bookingType === _vm.TYPE_HALLS
                ? _c(
                    "v-list",
                    {
                      staticClass: "pa-1",
                      staticStyle: { "border-radius": "0px" },
                      attrs: { elevation: "2", "three-line": "" },
                    },
                    [
                      _c("v-subheader", { attrs: { inset: "" } }, [
                        _vm._v(
                          " " + _vm._s(_vm.$t("overview.bookable_halls")) + " "
                        ),
                      ]),
                      _c("v-data-iterator", {
                        attrs: {
                          "disable-pagination": "",
                          "hide-default-footer": "",
                          "item-key": "Id",
                          items: _vm.itemsToDisplay
                            ? _vm.itemsToDisplay
                            : _vm.getFilteredHallItems(""),
                          "custom-filter": _vm.customHallFilter,
                          "custom-sort": _vm.customHallSort,
                          search: _vm.searchFor,
                          "no-results-text": _vm.$t("common.label_noresults"),
                          "no-data-text": _vm.$t("common.label_nodata"),
                          "sort-by": _vm.sortBy ? _vm.sortBy.key : undefined,
                          "sort-desc": _vm.sortBy
                            ? _vm.sortBy.sortDesc
                            : undefined,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _c(
                                    "v-row",
                                    {
                                      class:
                                        _vm.currentBreakpoint == 1
                                          ? "nomargin-firstchild nomargin-lastchild"
                                          : "",
                                      staticStyle: {
                                        "max-width": "calc(100vw - 32px)",
                                      },
                                      attrs: { "no-gutters": "" },
                                    },
                                    _vm._l(props.items, function (hall, index) {
                                      return _c("HallPreviewItem", {
                                        key: "hallListItem" + index,
                                        attrs: {
                                          selected:
                                            _vm.hasSelection &&
                                            _vm.currentSelection.Id === hall.Id,
                                          loading: _vm.loadingElem === hall.Id,
                                          disabled: _vm.loadingElem !== "",
                                          hallId: hall.Id,
                                        },
                                        on: {
                                          onSelect: function ($event) {
                                            return _vm.handleHallSelection(hall)
                                          },
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          193710955
                        ),
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.bookingType === _vm.TYPE_BOOKINGS
                ? _c(
                    "v-list",
                    {
                      staticClass:
                        "nomargin-firstchild nomargin-lastchild pa-1",
                      staticStyle: { "border-radius": "0px" },
                      attrs: { "three-line": "" },
                    },
                    [
                      _vm.bookedCourses && _vm.bookedCourses.length > 0
                        ? _c("v-subheader", { attrs: { inset: "" } }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("overview.mybookings_bookedCourses")
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                      _c(
                        "v-row",
                        {
                          class:
                            _vm.currentBreakpoint == 1
                              ? "nomargin-firstchild nomargin-lastchild"
                              : "",
                          staticStyle: { "max-width": "calc(100vw - 32px)" },
                          attrs: { "no-gutters": "" },
                        },
                        _vm._l(_vm.bookedCourses, function (course, index) {
                          return _c(
                            "CoursePreviewItem",
                            {
                              key: "personalBookedCourseListItem" + index,
                              attrs: {
                                selected:
                                  _vm.hasSelection &&
                                  _vm.currentSelection.CourseId ===
                                    course.CourseId,
                                loading: _vm.loadingElem === course.CourseId,
                                courseId: course.CourseId,
                                fromMyBookings: true,
                              },
                              on: {
                                onSelect: function ($event) {
                                  return _vm.handleCourseSelection(course)
                                },
                              },
                            },
                            [
                              _c(
                                "template",
                                { slot: "avatar" },
                                [
                                  _c(
                                    "v-card",
                                    {
                                      staticClass: "mr-4 white--text",
                                      attrs: {
                                        color: "teal accent-4",
                                        width: "64px",
                                        height: "128px",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        {
                                          staticClass: "text-center",
                                          staticStyle: { height: "100%" },
                                          attrs: {
                                            "no-gutters": "",
                                            justify: "center",
                                            align: "center",
                                          },
                                        },
                                        [
                                          _c("v-col", [
                                            _c("div", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.getNextMeetingCourse(
                                                    course
                                                  )
                                                ),
                                              },
                                            }),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            2
                          )
                        }),
                        1
                      ),
                      _vm.reservedCourses && _vm.reservedCourses.length > 0
                        ? _c("v-subheader", { attrs: { inset: "" } }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("overview.mybookings_reservedCourses")
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                      _c(
                        "v-row",
                        {
                          class:
                            _vm.currentBreakpoint == 1
                              ? "nomargin-firstchild nomargin-lastchild"
                              : "",
                          staticStyle: { "max-width": "calc(100vw - 32px)" },
                          attrs: { "no-gutters": "" },
                        },
                        _vm._l(_vm.reservedCourses, function (course, index) {
                          return _c(
                            "CoursePreviewItem",
                            {
                              key: "personalReservedCourseListItem" + index,
                              attrs: {
                                selected:
                                  _vm.hasSelection &&
                                  _vm.currentSelection.CourseId ===
                                    course.CourseId,
                                loading: _vm.loadingElem === course.CourseId,
                                disabled: _vm.loadingElem !== "",
                                courseId: course.CourseId,
                                fromMyBookings: true,
                              },
                              on: {
                                onSelect: function ($event) {
                                  return _vm.handleCourseSelection(course)
                                },
                              },
                            },
                            [
                              _c(
                                "template",
                                { slot: "avatar" },
                                [
                                  _c(
                                    "v-card",
                                    {
                                      staticClass: "mr-4 white--text",
                                      attrs: {
                                        color: "teal accent-4",
                                        width: "64px",
                                        height: "128px",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        {
                                          staticClass: "text-center",
                                          staticStyle: { height: "100%" },
                                          attrs: {
                                            "no-gutters": "",
                                            justify: "center",
                                            align: "center",
                                          },
                                        },
                                        [
                                          _c("v-col", [
                                            _c("div", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.getNextMeetingCourse(
                                                    course
                                                  )
                                                ),
                                              },
                                            }),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            2
                          )
                        }),
                        1
                      ),
                      _vm.bookedHallMeetings &&
                      _vm.bookedHallMeetings.length > 0
                        ? _c("v-subheader", { attrs: { inset: "" } }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("overview.mybookings_bookedHalls")
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                      _c(
                        "v-row",
                        {
                          class:
                            _vm.currentBreakpoint == 1
                              ? "nomargin-firstchild nomargin-lastchild"
                              : "",
                          staticStyle: { "max-width": "calc(100vw - 32px)" },
                          attrs: { "no-gutters": "" },
                        },
                        _vm._l(_vm.bookedHallMeetings, function (hall, index) {
                          return _c(
                            "HallPreviewItem",
                            {
                              key: "personalBookedhallListItem" + index,
                              attrs: {
                                selected:
                                  _vm.hasSelection &&
                                  _vm.currentSelection.Id === hall.Id,
                                loading: _vm.loadingElem === hall.Id,
                                disabled: _vm.loadingElem !== "",
                                hallId: hall.Id,
                                fromMyBookings: true,
                              },
                              on: {
                                onSelect: function ($event) {
                                  return _vm.handleHallSelection(hall)
                                },
                              },
                            },
                            [
                              _c(
                                "template",
                                { slot: "avatar" },
                                [
                                  _c(
                                    "v-card",
                                    {
                                      staticClass: "mr-4 white--text",
                                      attrs: {
                                        color: "teal accent-4",
                                        width: "64px",
                                        height: "128px",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        {
                                          staticClass: "text-center",
                                          staticStyle: { height: "100%" },
                                          attrs: {
                                            "no-gutters": "",
                                            justify: "center",
                                            align: "center",
                                          },
                                        },
                                        [
                                          _c("v-col", [
                                            _c("div", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.getNextMeetingHall(hall)
                                                ),
                                              },
                                            }),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            2
                          )
                        }),
                        1
                      ),
                      _vm.hasBookedOrReserved
                        ? _c("v-subheader", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("overview.mybookings_noBookings")
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("v-stepper-content", { staticClass: "pa-0", attrs: { step: 1 } }, [
            _vm.hasSelection && _vm.loadingElem === "" && _vm.step === 1
              ? _c(
                  "div",
                  { staticClass: "fill-height" },
                  [
                    _vm.bookingType === _vm.TYPE_COURSES ||
                    (_vm.bookingType == _vm.TYPE_BOOKINGS &&
                      _vm.getType(_vm.currentSelection) === _vm.TYPE_COURSES)
                      ? _c("CourseDetails", {
                          attrs: {
                            fromMyBookings:
                              _vm.bookingType === _vm.TYPE_BOOKINGS,
                            isBooking: _vm.isBooking,
                            isReservating: _vm.isReservating,
                            courseId: _vm.currentSelection.CourseId,
                          },
                          on: {
                            onBackButtonClick: function ($event) {
                              return _vm.goBackToOverview()
                            },
                            onBookingButtonClick: _vm.handleCourseBookingClick,
                            onReservationButtonClick:
                              _vm.handleCourseReservationClick,
                          },
                        })
                      : _vm._e(),
                    _vm.bookingType === _vm.TYPE_HALLS ||
                    (_vm.bookingType == _vm.TYPE_BOOKINGS &&
                      _vm.getType(_vm.currentSelection) === _vm.TYPE_HALLS)
                      ? _c("HallDetails", {
                          attrs: {
                            showBookedMeetings:
                              _vm.bookingType == _vm.TYPE_BOOKINGS &&
                              _vm.getType(_vm.currentSelection) ===
                                _vm.TYPE_HALLS,
                            fromMyBookings:
                              _vm.bookingType === _vm.TYPE_BOOKINGS,
                            isBooking: _vm.isBooking,
                            isReservating: _vm.isReservating,
                            hallId: _vm.currentSelection.Id,
                          },
                          on: {
                            onButtonBackClick: function ($event) {
                              return _vm.goBackToOverview()
                            },
                            onBookingClick: _vm.handleHallBookingClick,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _c(
            "v-stepper-content",
            { staticClass: "pa-0", attrs: { step: 2 } },
            [
              _vm.hasSelection && _vm.step == 2
                ? _c("HallMeetings", {
                    attrs: { hallId: _vm.currentSelection.Id },
                    on: {
                      onBookingDataInput: _vm.handleHallBookingInput,
                      onMeetingClick: _vm.handleMeetingClick,
                      onBookingClick: _vm.handleBookAction,
                      onBackClick: function ($event) {
                        return _vm.goBackToDetails()
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "v-stepper-content",
            { staticClass: "pa-0", attrs: { step: 3 } },
            [
              _vm.hasSelection && _vm.step === 3
                ? _c("PaymentDialog", {
                    ref: "paymentDialog",
                    attrs: {
                      itemType: _vm.getType(_vm.currentSelection),
                      itemIdToPayFor: _vm.currentSelectionId,
                      bookableItem: _vm.getBookingItem(),
                    },
                    on: {
                      onPaymentSuccess: _vm.handlePaymentSuccess,
                      onButtonBackClick: _vm.handlePaymentButtonBackClick,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "v-stepper-content",
            { staticClass: "pa-0", attrs: { step: 4 } },
            [
              _vm.step === 4
                ? _c(
                    "v-row",
                    [
                      _vm.step === 4 && _vm.successfulPayment
                        ? _c("PaymentSuccess", {
                            attrs: {
                              paymentOption:
                                _vm.successfulPayment.paymentOption,
                              price: _vm.successfulPayment.price,
                              feeAmount: _vm.successfulPayment.feeAmount,
                              fromMyBookings:
                                _vm.bookingType === _vm.TYPE_BOOKINGS,
                              type: _vm.successfulPayment.type,
                              bookedTitle: _vm.successfulPayment.title,
                            },
                            on: {
                              onButtonOverviewClick: function ($event) {
                                return _vm.goBackToOverviewAfterPayment()
                              },
                              onButtonMyBookingsClick: function ($event) {
                                return _vm.goToMyBookings()
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }